"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleLinkGenerator = exports.StandardLinkGenerator = void 0;
const Domains_1 = require("./Domains");
const uuid_1 = require("uuid");
const cookieName = '99externalurl', shortenThreshold = 48, shortenLeading = 35, shortenSeparator = '&hellip;', shortenTrailing = 10;
const hasScheme = /^(ht|f)tps?:\//i;
const StandardLinkGenerator = (domain) => {
    return (input, text) => {
        const caption = text !== null && text !== void 0 ? text : processCaption(input);
        let href = input;
        let output = '';
        if (href.match(hasScheme) == null) {
            href = 'http://' + href;
        }
        if (isExternalURL(href)) {
            const urlId = getOrCreateId();
            //js base64 sometimes append "=" at the end of out put strings which causes some tests to fail.
            href =
                '/x/' + b64EncodeUnicode(href).replace(/=*$/g, '') + (urlId ? '?id=' + urlId : '');
            if (domain !== '') {
                href = 'https://' + domain + href;
            }
            output += `<a class="link" href="${href}" target="_blank" rel="noreferrer external noopener nofollow">`;
        }
        else {
            output = `<a class="link" href="${href}" target="_blank">`;
        }
        output += `${caption}</a>`;
        return output;
    };
};
exports.StandardLinkGenerator = StandardLinkGenerator;
const SimpleLinkGenerator = (input, text) => {
    let url = input.trim();
    if (input.match(/^(ht|f)tps?:\/\//i) === null) {
        url = 'http://' + input;
    }
    return `<a href="${url}">${text !== null && text !== void 0 ? text : input}</a>`;
};
exports.SimpleLinkGenerator = SimpleLinkGenerator;
const processCaption = (caption) => {
    if (caption.length <= shortenThreshold) {
        return caption;
    }
    return (caption.substring(0, shortenLeading) +
        shortenSeparator +
        caption.substring(caption.length - shortenTrailing));
};
const isExternalURL = (urlStr) => {
    try {
        const url = new URL(urlStr);
        return Domains_1.Domains.find(domain => url.host.endsWith(domain)) === undefined;
    }
    catch (e) {
        return true;
    }
};
//Copied from https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_.232_.E2.80.93_rewriting_atob()_and_btoa()_using_TypedArrays_and_UTF-8
const b64EncodeUnicode = (str) => {
    let stdEncoding;
    if (isSsr()) {
        stdEncoding = Buffer.from(str).toString('base64');
    }
    else {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        stdEncoding = btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
            return String.fromCharCode(parseInt('0x' + p1));
        }));
    }
    // we use a modification of standard base64 encoding that avoids the non url safe characters
    // + (which is %20 encoded) and / (which is a path separator)
    return stdEncoding.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
function getOrCreateId() {
    if (isSsr()) {
        // do nothing for SSR
        return '';
    }
    let id = getCookieValue(cookieName);
    if (!id) {
        id = uuid_1.v4();
        const date = new Date();
        date.setTime(date.getTime() + 34560000000); // in 400 days (max allowed by chrome)
        document.cookie = `${cookieName}=${id};path=/;expires=${date.toUTCString()};domain=.${window.location.hostname}`;
    }
    return id;
}
function getCookieValue(cookieName) {
    try {
        const name = cookieName + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return '';
    }
    catch (e) {
        return '';
    }
}
function isSsr() {
    return typeof window === 'undefined';
}
